import { useState } from "react";

export default function SizeItem({
  item,
  index,
  handleSizeClick,
  handleQuantityChange,
  quantities,
  selectedItemIdx,
  isOutletStyle,
  styleNumber,
  isInactiveInput,
}) {
  const [focused, setFocused] = useState(false);

  const isActive = item.b2bActiveFlag === true;

  // Convert price and discount rate to numbers.
  // This prevents errors when API returns values as strings like "100.00" or "-25.00".
  const unitPrice = Number(item.unitPrice || 0);
  const discountRate = Number(item.discountRate || 0);

  // Check if this item has a discount.
  // DB discountRate can be negative, for example -25.00.
  const hasDiscount = Math.abs(discountRate) > 0;

  // Calculate discounted price.
  // Example: unitPrice 100, discountRate -25.00 => discountedPrice 75.00
  const discountedAmount = (unitPrice * Math.abs(discountRate)) / 100;
  const roundedDiscountAmount = Math.round(discountedAmount * 100) / 100;
  const discountedPrice = unitPrice - roundedDiscountAmount;

  // Active item
  const activeStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "9px",
    flexBasis: "calc(23% - 1px)",
    border:
      selectedItemIdx === index
        ? "1px solid var(--Primary-color---Teal, #04ADD1)"
        : "1px solid #C3C3C3",
    backgroundColor: "white",
    padding: "10px 9px",
    margin: "5.5px",
  };

  const inputStyle = {
    width: "96px",
    height: "26px",
    border: focused
      ? "1px solid var(--Primary-color---Teal, #04ADD1)"
      : "1px solid #090909",
    background: focused ? "rgba(4,226, 226, 226) 173, 209, 0.05)" : "white",
  };

  // Inactive item
  const inactiveStyle = {
    ...activeStyle,
    backgroundColor: "#E2E2E2",
    border: "1px solid #E2E2E2",
  };

  const inactiveInputStyle = {
    ...inputStyle,
    display: "inline-flex",
    padding: "10px 9px",
    alignItems: "flex-start",
    gap: "10px",
    // background: "#E2E2E2",
    background: "#EBEBEB",
    border: "1px solid #FFFFFF",
    pointerEvents: "none",
  };

  // ETA Format YYYY-MM-DD as MMM D, YYYY
  let nextArrivalDate = item.nextAvailDate;

  const formatNextArrivalDate = (dateString) => {
    if (!dateString) return "";

    const [year, month, day] = dateString.split("-").map(Number);

    return new Date(year, month - 1, day).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };
  return (
    <div
      style={isActive ? activeStyle : inactiveStyle}
      onClick={() => handleSizeClick(index)}
    >
      <div
        style={{
          color: isActive
            ? "var(--Primary-txt-Black, #0B0B0B)"
            : "var(--Base-White, #FFF)",
          fontFamily: "Lato",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "normal",
        }}
      >
        {item.itemSize}
      </div>
      <div
        style={{
          display: "flex",
          gap: "6px",
          alignItems: "center",
          // Always keep prices on one line.
          flexWrap: "nowrap",
          whiteSpace: "nowrap",
          // Keep the container size fixed.
          width: "96px",
          maxWidth: "96px",
          overflow: "hidden",

          fontFamily: "Lato",
          // Make font smaller only when both original price and discounted price are shown.
          fontSize: hasDiscount ? "14px" : "16px",
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "normal",
        }}
      >
        {hasDiscount ? (
          <>
            {/* Original unit price with line-through when discount exists */}
            <span
              style={{
                color: isActive
                  ? "var(--Body-txt-Grey, #474747)"
                  : "var(--Base-White, #FFF)",
                textDecoration: "line-through",

                // Prevent price from wrapping or shrinking weirdly.
                whiteSpace: "nowrap",
                flexShrink: 0,
              }}
            >
              ${unitPrice.toFixed(2)}
            </span>

            {/* Discounted price */}
            <span
              style={{
                color: isActive
                  ? "var(--Primary-color---Teal, #04ADD1)"
                  : "var(--Base-White, #FFF)",

                // Prevent price from wrapping.
                whiteSpace: "nowrap",
                flexShrink: 0,
              }}
            >
              ${discountedPrice.toFixed(2)}
            </span>
          </>
        ) : (
          /* No discount: show regular unit price only */
          <span
            style={{
              color: isActive
                ? "var(--Primary-color---Teal, #04ADD1)"
                : "var(--Base-White, #FFF)",
              whiteSpace: "nowrap",
            }}
          >
            ${unitPrice.toFixed(2)}
          </span>
        )}
      </div>
      <div
        style={{
          color: isActive
            ? "var(--Body-txt-Grey, #474747)"
            : "var(--Base-White, #FFF)",
          fontFamily: "Lato",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "normal",
        }}
      >
        {item.qtyAvailable > 0
          ? `In Stock: ${item.qtyAvailable}`
          : `In Stock: ${item.qtyAvailable}`}
      </div>
      <input
        type="text"
        style={isInactiveInput ? inactiveInputStyle : inputStyle}
        disabled={isInactiveInput} // Disable input when isInactiveInput is true
        value={quantities.find((q) => q.pid === item.pid)?.quantity || ""}
        onChange={(e) =>
          handleQuantityChange(
            e,
            item.pid,
            item.qtyAvailable,
            item.isPreorder,
            item.discountRate,
          )
        }
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      {nextArrivalDate ? (
        <div
          style={{
            display: "flex",
            width: "96px",
            padding: "5px",
            justifyContent: "center",
            alignItems: "center",
            gap: "3px",
            borderRadius: "3px",
            background: "var(--Neutral-200, #F9F9F9)",
          }}
        >
          <div
            style={{
              color: isActive
                ? "var(--Body-txt-Grey, #474747)"
                : "rgba(71, 71, 71, 0.50)",
              fontFamily: "Lato",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "normal",
              textAlign: "center",
              width: "100%",
            }}
          >
            {/* Next Arrival: {item.nextAvailDate}  */}
            Next Arrival: {formatNextArrivalDate(item.nextAvailDate)}
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            width: "96px",
            padding: "5px",
            justifyContent: "center",
            alignItems: "center",
            gap: "3px",
            borderRadius: "3px",
            background: "var(--Neutral-200, #F9F9F9)",
          }}
        >
          <div
            style={{
              color: isActive
                ? "var(--Body-txt-Grey, #474747)"
                : "rgba(71, 71, 71, 0.50)",
              fontFamily: "Lato",
              fontSize: "13px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "normal",
              textAlign: "center",
              width: "100%",
            }}
          >
            Next Arrival: Pending
          </div>
        </div>
      )}
    </div>
  );
}
